var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _g2, _g3, _rect2, _g4, _rect3, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSenseiLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 144",
    style: {
      enableBackground: "new 0 0 360 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010101;}\r\n\t.st1{fill:#35AFC8;}\r\n\t.st2{fill:#612466;}\r\n\t.st3{fill:#895B8C;}\r\n\t.st4{fill:#B091B2;}\r\n\t.st5{fill:url(#SVGID_1_);}\r\n\t.st6{fill:url(#SVGID_2_);}\r\n\t.st7{fill:url(#SVGID_3_);}\r\n\t.st8{fill:none;}\r\n\t.st9{enable-background:new    ;}\r\n\t.st10{fill:#676063;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.41,123.76c-3.82,0-6.32-2.22-6.32-5.54h2.1c0,2.22,1.72,3.61,4.22,3.61c2.84,0,4.23-1.19,4.23-3.05 c0-1.38-0.62-2.34-4.27-2.96c-3.68-0.65-5.78-1.79-5.77-4.63c0-2.84,2.27-4.68,5.78-4.68c3.63,0,5.87,1.96,5.87,5.16h-2.05 c0-1.93-1.31-3.22-3.79-3.23c-2.55,0-3.75,1.12-3.75,2.67c0,1.43,0.76,2.15,4.15,2.77c3.63,0.69,5.87,1.72,5.87,4.9 C164.67,122.02,162.11,123.76,158.41,123.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.68,119.67c-0.86,2.63-2.96,4.1-5.8,4.1c-3.53,0-6.3-2.82-6.3-6.43c0-3.56,2.77-6.47,6.19-6.47 c3.17,0,6.23,2.63,6.2,7l-10.34-0.01c0.26,2.55,2.22,4.06,4.25,4.06c1.74,0,2.98-0.83,3.65-2.27L177.68,119.67z M175.73,116.06 c-0.5-2.01-2.17-3.34-3.96-3.34c-1.69,0-3.49,1.24-4.01,3.34H175.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.77,123.81c-2.98,0-5.16-1.6-5.49-4.2h2.05c0.26,1.43,1.67,2.32,3.44,2.32c1.91,0,3.08-0.93,3.08-2 c0-0.86-0.33-1.5-3.34-1.91c-2.98-0.43-4.8-1.15-4.8-3.46c0-1.77,1.53-3.65,4.82-3.65c2.84,0,4.75,1.43,5.01,3.85h-2.05 c-0.29-1.31-1.46-1.98-2.96-1.98c-1.62,0-2.79,0.76-2.79,1.72c0,0.88,0.69,1.19,3.1,1.58c2.72,0.43,4.96,0.96,4.96,3.75 C200.81,122.26,198.71,123.81,195.77,123.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.66,119.69c-0.86,2.63-2.96,4.1-5.8,4.1c-3.53,0-6.3-2.82-6.3-6.43c0-3.56,2.77-6.47,6.19-6.47 c3.17,0,6.23,2.63,6.2,7l-10.34-0.01c0.26,2.55,2.22,4.06,4.25,4.06c1.74,0,2.98-0.83,3.65-2.27L213.66,119.69z M211.7,116.08 c-0.5-2.01-2.17-3.34-3.96-3.34c-1.69,0-3.49,1.24-4.01,3.34H211.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.05,123.51h-2.03l0.01-12.29h2.03L217.05,123.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.05,109.76h-2.03l0.01-1.79h2.03L217.05,109.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.37,123.49h-2.01v-7.5c0-1.89-1.05-3.28-3.02-3.28c-1.87,0-3.24,1.39-3.24,3.24v7.55h-2.04v-12.34h1.97v1.34 c0.84-1.03,2.11-1.65,3.59-1.65c3.02,0,4.74,2.16,4.74,5.22L189.37,123.49L189.37,123.49z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.19,41.79c0-0.07,0-0.14,0-0.2c0-0.14,0-0.27,0-0.41c0-0.19,0.01-0.38,0.03-0.56c0-0.02,0-0.03,0-0.05 c0.06-0.71,0.18-1.41,0.38-2.08v-0.01c0.06-0.19,0.12-0.38,0.18-0.57c0.04-0.11,0.08-0.21,0.12-0.32c0.03-0.08,0.06-0.15,0.09-0.23 c1.21-2.97,3.73-5.42,7.26-6.3c0.02-0.01,0.05-0.01,0.07-0.02c0.2-0.05,0.4-0.1,0.61-0.13l59.11-10.88c0.75-0.14,1.49-0.19,2.2-0.18 c-1.21-0.37-2.5-0.58-3.87-0.58l-70.05-0.04c-9.97-0.01-16.21,10.78-11.23,19.42l32.65,56.63l-16.78-49.8 C41.49,44.28,41.23,43.04,41.19,41.79z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.48,41.82c0-0.07,0-0.14,0-0.2c0-0.14,0-0.27,0-0.41c0-0.19-0.01-0.38-0.03-0.56c0-0.02,0-0.03,0-0.05 c-0.06-0.71-0.18-1.41-0.38-2.08v-0.01c-0.06-0.19-0.12-0.38-0.18-0.57c-0.04-0.11-0.08-0.21-0.12-0.32 c-0.03-0.08-0.06-0.15-0.09-0.23c-1.2-2.97-3.72-5.43-7.25-6.31c-0.02-0.01-0.05-0.01-0.07-0.02c-0.2-0.05-0.4-0.1-0.61-0.14 l-59.1-10.95c-0.75-0.14-1.48-0.2-2.2-0.18c1.21-0.37,2.5-0.58,3.87-0.58l70.05,0.04c9.97,0.01,16.19,10.8,11.2,19.43l-32.72,56.6 l16.84-49.78C103.18,44.32,103.44,43.07,103.48,41.82z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.44,49.23c0-0.04,0-0.07,0-0.11c0-0.07,0-0.15,0-0.22c0-0.1,0.01-0.2,0.01-0.3c0-0.01,0-0.02,0-0.03 c0.03-0.38,0.1-0.76,0.2-1.12c0,0,0,0,0-0.01c0.03-0.1,0.06-0.21,0.1-0.31c0.02-0.06,0.04-0.12,0.06-0.17 c0.02-0.04,0.03-0.08,0.05-0.12c0.65-1.6,2.01-2.92,3.91-3.4c0.01,0,0.03-0.01,0.04-0.01c0.11-0.03,0.22-0.05,0.33-0.07L93,37.5 c0.4-0.07,0.8-0.1,1.19-0.1c-0.65-0.2-1.35-0.31-2.09-0.32l-37.76-0.02c-5.37,0-8.74,5.81-6.05,10.47l17.6,30.53l-9.05-26.84 C56.6,50.57,56.46,49.9,56.44,49.23z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.02,49.25c0-0.04,0-0.07,0-0.11c0-0.07,0-0.15,0-0.22c0-0.1-0.01-0.2-0.01-0.3c0-0.01,0-0.02,0-0.03 c-0.03-0.38-0.1-0.76-0.2-1.12c0,0,0,0,0-0.01c-0.03-0.1-0.06-0.21-0.1-0.31c-0.02-0.06-0.04-0.12-0.06-0.17 c-0.02-0.04-0.03-0.08-0.05-0.12c-0.65-1.6-2.01-2.92-3.91-3.4c-0.01,0-0.03-0.01-0.04-0.01c-0.11-0.03-0.22-0.05-0.33-0.07 l-31.85-5.9c-0.4-0.07-0.8-0.11-1.19-0.1c0.65-0.2,1.35-0.31,2.09-0.31l37.76,0.02c5.37,0,8.73,5.82,6.04,10.47l-17.64,30.5 l9.08-26.83C89.86,50.59,89.99,49.92,90.02,49.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.38,53.64c0-0.02,0-0.04,0-0.06c0-0.04,0-0.07,0-0.11c0-0.05,0-0.1,0.01-0.15v-0.01 c0.02-0.2,0.05-0.39,0.1-0.57l0,0c0.02-0.05,0.03-0.1,0.05-0.16c0.01-0.03,0.02-0.06,0.03-0.09c0.01-0.02,0.02-0.04,0.02-0.06 c0.33-0.81,1.02-1.48,1.99-1.73c0.01,0,0.01,0,0.02,0c0.06-0.01,0.11-0.03,0.17-0.04l16.19-2.98c0.2-0.04,0.41-0.05,0.6-0.05 c-0.33-0.1-0.69-0.16-1.06-0.16l-19.19-0.01c-2.73,0-4.44,2.95-3.08,5.32l8.94,15.51l-4.6-13.64 C65.46,54.32,65.39,53.98,65.38,53.64z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.46,53.64c0-0.02,0-0.04,0-0.06c0-0.04,0-0.07,0-0.11c0-0.05,0-0.1-0.01-0.15v-0.01 c-0.02-0.2-0.05-0.39-0.1-0.57l0,0c-0.02-0.05-0.03-0.1-0.05-0.16c-0.01-0.03-0.02-0.06-0.03-0.09c-0.01-0.02-0.02-0.04-0.02-0.06 c-0.33-0.81-1.02-1.49-1.99-1.73c-0.01,0-0.01,0-0.02,0c-0.05-0.01-0.11-0.03-0.17-0.04l-16.19-3c-0.2-0.04-0.41-0.05-0.6-0.05 c0.33-0.1,0.69-0.16,1.06-0.16l19.19,0.01c2.73,0,4.44,2.96,3.07,5.32l-8.96,15.5l4.61-13.64C82.38,54.32,82.45,53.98,82.46,53.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.6548,
    y1: 117.576,
    x2: 51.4675,
    y2: 120.4562,
    gradientTransform: "matrix(1 0 0 -1 0 144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#35AFC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0688,
    style: {
      stopColor: "#2D94A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#216D7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3001,
    style: {
      stopColor: "#174B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4217,
    style: {
      stopColor: "#0F3037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#081B1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6809,
    style: {
      stopColor: "#040C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8249,
    style: {
      stopColor: "#010303"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M72.69,26.78l-37-6.85c0,0-1.29-0.21-2.25-0.14c0,0-1.43,0.3-3.54,1.74l22.17,8.98L72.69,26.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.4207,
    y1: 103.238,
    x2: 61.8738,
    y2: 104.6097,
    gradientTransform: "matrix(1 0 0 -1 0 144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#35AFC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0688,
    style: {
      stopColor: "#2D94A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#216D7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3001,
    style: {
      stopColor: "#174B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4217,
    style: {
      stopColor: "#0F3037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#081B1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6809,
    style: {
      stopColor: "#040C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8249,
    style: {
      stopColor: "#010303"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.24,41.13L53.3,37.44c0,0-0.51-0.11-1.03-0.07c0,0-1.07,0.3-2,1l11.91,4.79L73.24,41.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.8942,
    y1: 94.4226,
    x2: 68.2334,
    y2: 95.6493,
    gradientTransform: "matrix(1 0 0 -1 0 144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#35AFC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0586,
    style: {
      stopColor: "#2D94A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1549,
    style: {
      stopColor: "#216D7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2554,
    style: {
      stopColor: "#174B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    style: {
      stopColor: "#0F3037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    style: {
      stopColor: "#081B1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5795,
    style: {
      stopColor: "#040C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7021,
    style: {
      stopColor: "#010303"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8511,
    style: {
      stopColor: "#000000"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M73.96,49.52c0,0-5.54-1.03-5.74-1.07c-0.12-0.02-2.67-0.5-2.92-0.54c-0.25-0.05-1.49-0.27-1.49-0.27 s-0.28-0.05-0.53-0.04c0,0-0.5,0.12-1.03,0.51l6.07,2.44L73.96,49.52z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.45,
    y: 22.19,
    className: "st8",
    width: 326.98,
    height: 84.87
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.76,54.96h-3.74V24.39h12.86c6.3,0,9.82,3.83,9.82,9.25c0,5.37-3.52,9.25-9.82,9.25h-9.12V54.96z M136.76,27.96v11.37 h9.12c3.57,0,6.12-1.67,6.12-5.68s-2.56-5.68-6.12-5.68H136.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.21,52.36c-1.63,1.98-4.27,3.13-7.8,3.13c-4.67,0-8.85-2.11-8.85-7c0-4.67,3.39-6.78,9.25-7.09 c5.55-0.26,7.36-1.28,7.36-3.08c0-1.81-1.72-3.17-5.55-3.17c-2.38,0-5.51,0.75-5.9,4.05h-3.88c0.26-4.54,4.01-7.49,9.82-7.49 c6.08,0,9.16,2.82,9.16,7.05v12.51c0,1.15,0.31,2.82,0.66,3.7h-3.7C174.47,54.3,174.25,53.42,174.21,52.36z M174.17,42.76 c-1.5,1.32-4.18,1.63-6.87,1.81c-4.93,0.31-6.04,2.03-6.04,3.92c0,2.47,2.38,3.52,5.29,3.52c3.88,0,7.53-1.67,7.62-5.77V42.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.72,54.96c-5.29,0.62-8.94-2.51-8.94-8.28V35.84h-3.08v-3.57h3.08v-4.85h3.7v4.85h5.15v3.57h-5.15v10.84 c0,4.01,2.47,5.02,5.24,4.85V54.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74,28.84H198v-4.45h3.75V28.84z M201.74,54.96H198V32.27h3.75V54.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.88,47.91c-1.59,4.85-5.46,7.58-10.71,7.58c-6.52,0-11.63-5.2-11.63-11.85c0-6.56,5.11-11.94,11.41-11.94 c5.86,0,11.5,4.85,11.45,12.91h-19.07c0.48,4.71,4.1,7.49,7.84,7.49c3.22,0,5.51-1.54,6.74-4.19H228.88z M225.27,41.26 c-0.92-3.7-4.01-6.17-7.31-6.17c-3.13,0-6.43,2.29-7.4,6.17H225.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.93,54.96h-3.7V41.17c0-3.48-1.94-6.04-5.55-6.04c-3.44,0-5.95,2.55-5.95,5.95v13.88h-3.75V32.27h3.61v2.47 c1.54-1.89,3.88-3.04,6.61-3.04c5.55,0,8.72,3.96,8.72,9.6V54.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.39,54.96c-5.29,0.62-8.94-2.51-8.94-8.28V35.84h-3.08v-3.57h3.08v-4.85h3.7v4.85h5.15v3.57h-5.15v10.84 c0,4.01,2.47,5.02,5.24,4.85V54.96z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.76,74.88h15.33v3.48h-15.33v14.27h-3.74V62.06h20.84v3.57h-17.09V74.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.14,81.35c0,6.52-4.93,11.81-11.41,11.81c-6.43,0-11.41-5.29-11.41-11.81c0-6.61,4.98-11.98,11.41-11.98 C174.21,69.37,179.14,74.75,179.14,81.35z M175.4,81.35c0-4.71-3.44-8.55-7.67-8.55c-4.18,0-7.62,3.83-7.62,8.55 c0,4.62,3.44,8.37,7.62,8.37C171.96,89.72,175.4,85.98,175.4,81.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.96,73.12c-3.92-0.22-7.27,1.85-7.27,6.39v13.13h-3.74V69.94h3.61v2.56c1.72-2.42,4.8-3.39,7.4-3.08V73.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.3,92.63h-3.75V78.49c0-3.52-1.67-5.68-5.15-5.68c-3.08,0-5.33,2.55-5.33,5.95v13.88h-3.7V78.49 c0-3.52-1.76-5.68-5.11-5.68c-3.08,0-5.37,2.55-5.37,5.95v13.88h-3.74V69.94h3.61v2.47c1.41-1.9,3.52-3.04,6.04-3.04 c3.22,0,5.59,1.45,7,3.88c1.41-2.34,3.83-3.88,7.09-3.88c5.24,0,8.41,3.57,8.41,9.21V92.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.88,93.2c-5.51,0-9.52-2.95-10.13-7.75h3.79c0.48,2.64,3.08,4.27,6.34,4.27c3.52,0,5.68-1.72,5.68-3.7 c0-1.59-0.62-2.78-6.17-3.52c-5.51-0.79-8.85-2.11-8.85-6.39c0-3.26,2.82-6.74,8.9-6.74c5.24,0,8.77,2.64,9.25,7.09h-3.79 c-0.53-2.42-2.69-3.66-5.46-3.66c-3,0-5.15,1.41-5.15,3.17c0,1.63,1.28,2.2,5.73,2.91c5.02,0.79,9.16,1.76,9.16,6.92 C255.18,90.34,251.3,93.2,245.88,93.2z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102.8,
    y: 105.93,
    className: "st8",
    width: 70.7,
    height: 29.67
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M134.77,118.88l-1.77,4.83h-2.2l6.26-16.58h2.29l6.14,16.58h-2.27l-1.74-4.83H134.77z M138.16,109.61 l-2.7,7.38h5.35L138.16,109.61z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 207.27,
    y: 105.9,
    className: "st8",
    width: 115.45,
    height: 29.67
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227.36,123.69h-2.03V107.1h6.98c3.42,0,5.33,2.08,5.33,5.02c0,2.92-1.91,5.02-5.33,5.02h-4.95V123.69z  M227.36,109.04v6.17h4.95c1.94,0,3.32-0.91,3.32-3.08s-1.39-3.08-3.32-3.08H227.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M245.98,113.1c-2.13-0.12-3.94,1-3.94,3.46v7.12h-2.03v-12.31h1.96v1.39c0.93-1.31,2.6-1.84,4.01-1.67V113.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M259.48,117.57c0,3.54-2.68,6.4-6.19,6.4c-3.49,0-6.19-2.87-6.19-6.4c0-3.58,2.7-6.5,6.19-6.5 C256.81,111.07,259.48,113.98,259.48,117.57z M257.45,117.57c0-2.56-1.86-4.64-4.16-4.64c-2.27,0-4.13,2.08-4.13,4.64 c0,2.51,1.86,4.54,4.13,4.54C255.59,122.11,257.45,120.08,257.45,117.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M273.56,123.69h-1.96v-1.98c-0.86,1.27-2.44,2.29-4.25,2.29c-3.54,0-6.17-2.89-6.17-6.45 c0-3.56,2.63-6.48,6.17-6.48c1.77,0,3.3,0.98,4.18,2.17v-7.34h2.03V123.69z M267.35,112.96c-2.32,0-4.13,2.05-4.13,4.61 c0,2.51,1.82,4.56,4.13,4.56c2.27,0,4.18-2.06,4.18-4.56C271.53,115.01,269.62,112.96,267.35,112.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M286.93,123.69h-1.96v-1.34c-0.84,1-2.08,1.62-3.58,1.62c-3.01,0-4.73-2.15-4.73-5.19v-7.41h2.01v7.5 c0,1.96,1.08,3.25,3.03,3.25c1.82,0,3.2-1.36,3.2-3.2v-7.55h2.03V123.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M295.68,123.97c-3.39,0-6.17-2.87-6.17-6.43c0-3.56,2.77-6.48,6.17-6.48c2.75,0,4.9,1.62,5.73,4.11h-2.17 c-0.69-1.34-1.96-2.25-3.56-2.25c-2.27,0-4.13,2.08-4.13,4.61c0,2.53,1.86,4.56,4.13,4.56c1.62,0,2.89-0.91,3.56-2.25h2.17 C300.6,122.35,298.42,123.97,295.68,123.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M309.04,123.69c-2.87,0.33-4.85-1.36-4.85-4.49v-5.88h-1.67v-1.94h1.67v-2.63h2.01v2.63h2.8v1.94h-2.8v5.88 c0,2.17,1.34,2.72,2.84,2.63V123.69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenseiLogo);
export default __webpack_public_path__ + "static/media/Sensei_Logo.f412f6449c315fe38498f8d85d72956e.svg";
export { ForwardRef as ReactComponent };